import { handleActions } from 'redux-actions';
import * as actions from './actions';

const initialState = [];

export const savedVideosReducer = handleActions(
  {
    [actions.SAVED_VIDEOS_FETCH_SUCCESS]: (prevState, { payload: { savedVideos } }) => ({
      savedVideos,
    }),
  },
  initialState
);
